import { Avatar, Dialog, DialogContent, DialogTitle, Grid, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip } from "@material-ui/core";
import { ArrowLeft, Close, KeyboardBackspace } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import ReactImageGallery from "react-image-gallery";
import Rating from "react-rating";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Autoplay, Pagination } from "swiper";
import _ from "underscore";
import { getProductRequest } from "../../store/shopping/shopping.actions";
import { getProducts } from "../../store/shopping/shopping.selector";
import { getImage, getSearchedUsers, getUserProfile } from "../../store/user/user.selector";

const ViewStore = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isreview, showReview] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const { products, userProfile, users } = useSelector((state) => {
        return {
            products: getProducts(state),
            userProfile: getUserProfile(state),
            users: getSearchedUsers(state)
        };
    });

    useEffect(() => {
        dispatch(getProductRequest(userProfile._id));
    }, []);

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <a
                onClick={() => navigate("/page/store")}
                className="text-md font-medium text-black-90 py-[7px]"
            >
                <KeyboardBackspace /> Back
            </a>
            <div className=" flex justify-between items-center mb-5">
                <div className="flex items-center">
                    <img
                        src={getImage(userProfile.avatar.attachments)}
                        alt=""
                        className="w-20 h-20 rounded-full mr-5"
                    />
                    <h2 className="text-2xl font-bold text-ebony-color capitalize">
                        {userProfile.fullName}’ Shop
                    </h2>
                </div>
                <button
                    onClick={() => navigate("/page/profile")}
                    className="text-md font-medium text-black-50 py-[7px] px-3.5 rounded-lg border border-black-10 capitalize  bg-white"
                >
                    View profile
                </button>
            </div>
            {
                selectedProduct._id && <Dialog maxWidth="lg" fullWidth open={isreview} onClose={() => showReview(false)}>
                    <DialogTitle>
                        All Reviews
                        <Close className="float-right" onClick={() => showReview(false)} />
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            {
                                selectedProduct && selectedProduct.reviews.map((x) => {
                                    const usr = _.find(users, s => s._id === x.user);
                                    return <Grid item xs={12} sm={12} lg={6} md={6}>
                                        <List disablePadding>
                                            <ListItem disableGutters>
                                                <ListItemAvatar>
                                                    <Avatar src={usr ? getImage(usr.attachments) : getImage("")} />
                                                </ListItemAvatar>
                                                <ListItemText primary={usr && usr.fullName} secondary={
                                                    <Rating
                                                        initialRating={x.rating}
                                                        fractions={2}
                                                        quiet

                                                        emptySymbol={
                                                            <span className="icon-text">
                                                                <span>
                                                                    <svg
                                                                        width="19"
                                                                        height="18"
                                                                        viewBox="0 0 19 18"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M9.43273 0L11.5558 6.53405H18.4261L12.8679 10.5723L14.9909 17.1064L9.43273 13.0681L3.87454 17.1064L5.99758 10.5723L0.439381 6.53405H7.30969L9.43273 0Z"
                                                                            fill="#C1C1C1"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </span>
                                                        }
                                                        fullSymbol={[1, 2, 3, 4, 5].map((n) => (
                                                            <span className="icon-text">
                                                                <span>
                                                                    <svg
                                                                        width="19"
                                                                        height="18"
                                                                        viewBox="0 0 19 18"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path
                                                                            d="M9.94445 0L12.0675 6.53405H18.9378L13.3796 10.5723L15.5027 17.1064L9.94445 13.0681L4.38625 17.1064L6.5093 10.5723L0.951099 6.53405H7.82141L9.94445 0Z"
                                                                            fill="#FFB800"
                                                                        />
                                                                    </svg>
                                                                </span>
                                                            </span>
                                                        ))}
                                                    />
                                                } />
                                                <ListItemSecondaryAction>
                                                    {moment(x.dateCreated).fromNow()}
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <ListItem disableGutters>
                                                <ListItemText primary={x.description} />
                                            </ListItem>
                                        </List>

                                    </Grid>
                                })
                            }
                            {
                                selectedProduct && selectedProduct.reviews.length === 0 &&
                                <Alert severity="info" className="mb-4">
                                    No Reviews yet
                                </Alert>
                            }
                        </Grid>

                    </DialogContent>
                </Dialog>
            }


            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 flex-1 overflow-y-auto overflow-hidden ">
                {products.map((product) => {
                    return (
                        <div
                            key={product.id}
                            className="w-full h-[440px] mx-auto border border-black-10 rounded-lg bg-white"
                        >
                            <div className="mb-2.5 bg-[#F5F5F5] relative rounded-tr-lg rounded-tl-lg">
                                {/* <Swiper
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={true}
                                    loop={true}
                                    modules={[Autoplay, Pagination]}
                                    className="mySwiper"
                                >
                                    {[
                                        product.attachments,
                                        ...product.allAttachments,
                                    ].map((productImage) => {
                                        return (
                                            <SwiperSlide key={productImage._id}>
                                                <div className="">
                                                    <img
                                                        src={getImage(
                                                            productImage
                                                        )}
                                                        className="w-full object-fill"
                                                        style={{ height: 200 }}
                                                        alt=""
                                                    />
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper> */}
                                <ReactImageGallery
                                    key={product.id}
                                    autoPlay
                                    // showNav={false}
                                    showPlayButton={false}
                                    items={
                                        product.allAttachments.length > 0
                                            ? product.allAttachments
                                                .concat(product.attachments)
                                                .map((x) => {
                                                    return {
                                                        thumbnailWidth: 32,
                                                        thumbnailHeight: 32,
                                                        id: x._id,
                                                        original: getImage(x),
                                                        thumbnail:
                                                            getImage(x),
                                                    };
                                                })
                                            : [
                                                {
                                                    thumbnailWidth: 32,
                                                    thumbnailHeight: 32,
                                                    id: product.attachments
                                                        ._id,
                                                    original: getImage(
                                                        product.attachments
                                                    ),
                                                    thumbnail: getImage(
                                                        product.attachments
                                                    ),
                                                },
                                            ]
                                    }
                                />
                            </div>

                            <div className="px-4 py-2.5 relative">
                                <div className="absolute right-0 top-[-20px] p-2 z-10">
                                    <button className="py-0.5 px-1.5 bg-orange-color text-white text-sm font-medium capitalize rounded-lg w-fit">
                                        sold: {product.warehouse.purcharse}
                                    </button>
                                </div>
                                <div className="mb-[25px]">
                                    <h3 className="text-sm font-bold text-black-color mb-0.5 overflow-text">
                                        {product.name}
                                    </h3>
                                    <Tooltip title={product.descriptions}>
                                        <p className="text-sm font-normal text-black-60 h-[20px] overflow-y-scroll overflow-text">
                                            {product.descriptions}
                                        </p>
                                    </Tooltip>
                                </div>

                                <div className="">
                                    <div className="flex items-end gap-x-1 text-purple-color mb-1.5">
                                        <p className="text-sm font-bold uppercase">
                                            {product.currency} {product.price}
                                        </p>
                                        <p className="text-[9px] ">
                                            {product.discount}
                                        </p>
                                    </div>
                                    <div className="flex items-center justify-between mb-2.5">
                                        <p className="text-sm font-medium text-black-color capitalize">
                                            stock: {product.warehouse.remaining}
                                        </p>
                                        <button onClick={() => {
                                            setSelectedProduct(product);
                                            showReview(true)
                                        }} className="text-sm font-normal text-black-60 capitalize">
                                            See Reviews
                                        </button>
                                    </div>
                                </div>

                                <div className="flex items-center gap-2 mb-4">
                                    <button className="py-[7px] w-full block text-sm font-medium text-black-50 rounded-lg bg-gray-300 border border-black-10 whitespace-nowrap">
                                        Add to cart
                                    </button>
                                    <button className="py-[7px] w-full block text-sm font-medium text-black-50 rounded-lg bg-gray-300 border border-black-10 whitespace-nowrap">
                                        Buy it now
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {products.length === 0 && (
                <div className="text-center h-[70vh] text-lg text-black-50 flex text-center items-center justify-center flex-col">
                    <svg
                        width="150"
                        height="150"
                        viewBox="0 0 18 18"
                        className="stroke-current"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M10.25 16.5V10.25C10.25 10.0842 10.3159 9.92527 10.4331 9.80806C10.5503 9.69085 10.7093 9.625 10.875 9.625H13.375C13.5408 9.625 13.6997 9.69085 13.817 9.80806C13.9342 9.92527 14 10.0842 14 10.25V16.5M10.25 16.5H0.966679M10.25 16.5H14M14 16.5H17.0333M15.875 16.5V6.79083C16.2072 6.59909 16.4908 6.33349 16.7038 6.01459C16.9169 5.6957 17.0538 5.33205 17.1038 4.95179C17.1538 4.57154 17.1157 4.18487 16.9924 3.82171C16.869 3.45855 16.6638 3.12864 16.3925 2.8575L15.4008 1.86667C15.1667 1.63218 14.8489 1.50029 14.5175 1.5H3.48168C3.15027 1.50029 2.83254 1.63218 2.59835 1.86667L1.60751 2.85667C1.33688 3.12811 1.13219 3.45809 1.00924 3.82114C0.886282 4.1842 0.848342 4.57064 0.898343 4.95068C0.948343 5.33072 1.08495 5.6942 1.29763 6.01309C1.5103 6.33199 1.79337 6.59779 2.12501 6.79M2.12501 16.4992V6.79167C2.62503 7.07999 4.68075 6.17674 5.25033 6.08333C7.75033 8.16667 12.2917 6.7975 12.75 6.27833C13.1319 6.71112 13.6516 6.99852 14.2212 7.09178C14.7908 7.18504 15.3751 7.07842 15.875 6.79"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="my-2">
                        There is currently no product in your store. Start
                        listing your products for sale.
                    </span>
                    <button
                        onClick={() => navigate("/page/store")}
                        className="py-2.5 px-5 rounded-lg capitalize text-sm bg-orange-color text-white border border-transparent font-bold"
                    >
                        Add product
                    </button>
                </div>
            )}
        </div>
    );
};

export default ViewStore;
